import React, { useCallback } from 'react'
import { ReactComponent as AddIcon } from '../add.svg'
import style from '../DataTable.module.scss'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames/bind'
import { ReactTableDefaults } from 'react-table'


const withAddIcon = Component => ({ TheadComponent = ReactTableDefaults.TheadComponent, onAddRecord, ...props }) => {
	const { t } = useTranslation()
	const IconTheadComponent = useCallback(theadProps => {
		return(
			<>
				<TheadComponent {...theadProps}/>
				<AddIcon
					title={t('product_section.strings.add')}
					className={classNames(style.addIcon)}
					onClick={e => {
						e.stopPropagation()
						onAddRecord(e)
					}}/>
			</>
		)
	}, [TheadComponent, onAddRecord])

	return (
		<Component
			{...props}
			TheadComponent={IconTheadComponent}
		/>
	)
}

export default withAddIcon
